import { queryOptions } from "@tanstack/react-query";
import { api } from "./utils";

export function countriesQuery(includeUnsupported: boolean) {
  return queryOptions({
    queryKey: ["countries", includeUnsupported],
    queryFn: async () => api.location.getCountries({ includeUnsupported }),
  });
}

export const regionsQuery = (countryCode: string | undefined) =>
  queryOptions({
    queryKey: ["regions", countryCode],
    queryFn: async () => (countryCode ? (await api.location.getRegions({ countryCode })).regions : []),
  });

export const locationTypesQuery = queryOptions({
  queryKey: ["location-types"],
  queryFn: async () => (await api.location.getLocationTypes()).types,
});

export const timezonesQuery = (countryCode: string) =>
  queryOptions({
    queryKey: ["timezones", countryCode],
    queryFn: async () => (countryCode ? (await api.location.getTimezones({ countryCode })).timezones : []),
  });
